import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Link } from "~/components-shared";
import { AnimClassEnum, AnimOrderEnum } from "~/types/enums";
import { useTranslation } from "react-i18next";
const Wrapper = styled.footer`
  display: flex;
  min-height: 70px;
  align-items: center;
  justify-content: center;
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.text.secondary;
}};
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.background.primary;
}};
`;
const Footer = _ref3 => {
  let {
    ...rest
  } = _ref3;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: `${AnimOrderEnum.ONE} ${AnimClassEnum.POP_BOTTOM_FADE}`
  }, rest), `© ${new Date().getFullYear()} • ${t("Auth.poweredBy")} •`, /*#__PURE__*/React.createElement(Link, {
    href: t("Auth.privacyPolicyUrl"),
    s: {
      mx: 1
    }
  }, t("Auth.privacyPolicy")), " • ", /*#__PURE__*/React.createElement(Link, {
    href: t("Auth.termsOfUseUrl"),
    s: {
      mx: 1
    }
  }, t("Auth.termsOfUse")));
};
export default Footer;